import { provide, reactive } from "@vue/composition-api"
import {ErrorsContext} from '../contexts';

export const provideErrors = (errorKeys) => provide(ErrorsContext, reactive({
    // get an object with falsy values from errorKeys array
    messages:  errorKeys.reduce((a,b) => (a[b] = false, a), {}),

    // setting error value (boolean) for each key
    setError(key, value) {
        this.messages[key] = value;
    },

    hasError(){
        return Object.values(this.messages).some(item => item)
    },

    resetErrors(){
        for(let key in this.messages) {
            this.messages[key] = false
        }
    }
}))